import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Klik på knappen herunder for at gennemgå og bekræfte dine betalingsoplysninger.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Vi samarbejder med Stripe om håndtering af betalinger. Stripe er den mest sikre betalingsplatform, som bruges af verdens største virksomheder.',
      form: {
        terms_acceptance: {
          label:
            'Ved at fortsætte accepterer du vores <FoodAmigosTerms>servicevilkår</FoodAmigosTerms> og <StripeTerms>Stripes aftale for tilknyttede konti.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements: 'Stripe mangler stadig nedenstående oplysninger eller kunne ikke bekræfte dem:',
        errors: 'Fejl',
        awaiting_verification: 'Din Stripe-konto bliver verificeret',
        awaiting_verification_description:
          'Vi venter på, at Stripe færdiggør verificeringen af din virksomhed. Du kan imens gennemgå din profil.',
        details_hint:
          'Stripe kontrollerer navne, adresser og telefonnumre op mod officielle registre. Hvis en af dem er forkert, så ret den under Mine oplysninger → Personlige oplysninger, så kontrollerer Stripe den igen. Alt andet, Stripe beder om, kan du tilføje i din Stripe-profil.',
        requirements_hint:
          'Nogle af disse er dokumenter, f.eks. dit ID: upload dem i det forrige trin, {{step}}, og kom så tilbage hertil.',
        requirements_hint_profile: 'Nogle af disse er dokumenter, f.eks. dit ID: upload dem i din Stripe-profil.',
      },
      requirements: {
        of_subject: '{{subject}}: {{detail}}',
        subjects: {
          owner: 'Ejer',
          representative: 'Repræsentant',
          business: 'Virksomhed',
        },
        details: {
          first_name: 'Fornavn',
          last_name: 'Efternavn',
          email: 'E-mail',
          phone: 'Telefonnummer',
          dob: 'Fødselsdato',
          id_number: 'ID-nummer',
          nationality: 'Nationalitet',
          address: 'Gade og husnummer',
          city: 'By',
          postal_code: 'Postnummer',
          state: 'Region',
          country: 'Land',
          id_document: 'ID-dokument',
          proof_of_address: 'Adressebevis',
          job_title: 'Jobtitel',
          business_name: 'Juridisk firmanavn',
          tax_id: 'Skattenummer',
          vat_id: 'Moms-id',
          registration_number: 'Registreringsnummer',
          website: 'Hjemmeside',
          industry: 'Branche',
          product_description: 'Beskrivelse af hvad du sælger',
          support_phone: 'Telefonnummer til kundeservice',
          owners: 'Bekræftelse af ejerne',
          directors: 'Bekræftelse af direktørerne',
          executives: 'Bekræftelse af ledelsen',
          registration_document: 'Virksomhedsregistreringsdokument',
          bank_account: 'Bankkonto til udbetalinger',
          business_type: 'Virksomhedstype',
          terms: 'Accept af Stripes vilkår',
          bank_account_proof: 'Bevis for ejerskab af bankkonto',
          tax_id_document: 'Skattenummerdokument',
        },
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Vi samarbejder med Adyen om håndtering af betalinger. Adyen er en af de mest sikre betalingsplatforme, som bruges af verdens største virksomheder.',
    },
  },
  labels: {
    verified: 'Din {{paymentGateway}}-konto er verificeret',
    verified_description:
      'Verificeringen er gennemført for {{paymentGateway}}. Du kan stadig administrere din profil, hvis det er nødvendigt.',
  },
  buttons: {
    proceed: 'Bekræft mine betalingsoplysninger',
    copy_link: 'Kopiér link',
    back: 'Tilbage',
  },
  toasts: {
    something_went_wrong: 'Noget gik galt. Kontakt teknisk support',
  },
};
